import { Building2, HeartHandshake, Mic, GraduationCap, ArrowUpRight } from "lucide-react";

const SERVICES = [
  {
    id: "corporate",
    num: "01",
    icon: Building2,
    title: "Corporate Video",
    blurb:
      "Brand films, internal comms, executive interviews and recruitment videos that earn attention and trust.",
    bullets: ["Brand films", "Executive interviews", "Internal comms", "Recruitment"],
  },
  {
    id: "nonprofit",
    num: "02",
    icon: HeartHandshake,
    title: "Nonprofit Fundraising",
    blurb:
      "Mission-driven story films built to move donors, fill rooms, and turn galas into momentum.",
    bullets: ["Gala / event reels", "Donor appeals", "Impact stories", "Campaign launches"],
  },
  {
    id: "podcast",
    num: "03",
    icon: Mic,
    title: "Podcast Production",
    blurb:
      "Studio-grade audio and multi-cam video podcasts — produced, edited and distributed end-to-end.",
    bullets: ["Multi-cam capture", "Audio engineering", "Short-form clips", "Distribution"],
  },
  {
    id: "courses",
    num: "04",
    icon: GraduationCap,
    title: "Video Courses",
    blurb:
      "Polished educational series with motion graphics, structured curriculum, and frame-perfect editing.",
    bullets: ["Curriculum design", "On-screen graphics", "Lesson editing", "Platform-ready exports"],
  },
];

export default function Services() {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="relative py-24 md:py-36 px-6 md:px-12 lg:px-16"
    >
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-16 md:mb-24 reveal">
        <div>
          <p className="eyebrow text-[#E60000] mb-5">/ Services</p>
          <h2 className="font-display uppercase text-5xl md:text-7xl leading-[0.9]">
            What we<br />
            <span className="text-outline">make.</span>
          </h2>
        </div>
        <p className="md:max-w-md text-white/70 leading-relaxed text-base md:text-lg">
          Four focused service tracks — built around the formats we know best.
          Every project is produced in-house from concept to color.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-px bg-[#1a1a1a] border border-[#1a1a1a]">
        {SERVICES.map((s, idx) => {
          const Icon = s.icon;
          return (
            <article
              key={s.id}
              data-testid={`service-${s.id}`}
              className="group relative bg-[#0a0a0a] hover:bg-[#0f0f0f] transition-colors duration-500 p-8 md:p-12 reveal"
              style={{ transitionDelay: `${idx * 60}ms` }}
            >
              <div className="flex items-start justify-between mb-10 md:mb-16">
                <span className="eyebrow text-white/40">{s.num}</span>
                <ArrowUpRight
                  size={24}
                  className="text-white/30 group-hover:text-[#E60000] group-hover:-translate-y-1 group-hover:translate-x-1 transition-all duration-300"
                />
              </div>

              <div className="flex items-center gap-4 mb-6">
                <span className="inline-flex h-12 w-12 items-center justify-center border border-[#222] text-[#E60000] group-hover:border-[#E60000] transition-colors">
                  <Icon size={20} strokeWidth={1.5} />
                </span>
                <h3 className="font-display-md uppercase text-2xl md:text-3xl tracking-tight">
                  {s.title}
                </h3>
              </div>

              <p className="text-white/70 leading-relaxed md:text-lg max-w-md mb-8">
                {s.blurb}
              </p>

              <ul className="flex flex-wrap gap-2">
                {s.bullets.map((b) => (
                  <li
                    key={b}
                    className="text-[11px] uppercase tracking-[0.18em] font-semibold text-white/60 px-3 py-2 border border-[#222]"
                  >
                    {b}
                  </li>
                ))}
              </ul>
            </article>
          );
        })}
      </div>
    </section>
  );
}
